
import { BookingFormData } from "@/components/ParcelBookingForm";

interface AddressHandlersProps {
  formData: BookingFormData;
  setFormData: React.Dispatch<React.SetStateAction<BookingFormData>>;
  validateAddresses: (collection: any, delivery: any) => boolean;
}

export const useAddressHandlers = ({ 
  formData, 
  setFormData, 
  validateAddresses 
}: AddressHandlersProps) => {
  const handleCollectionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let updatedAddress;
    
    // Handle batch update for clearing addresses
    if (e.target.dataset?.batchUpdate && (e.target as any).batch) {
      updatedAddress = {
        ...formData.collectionAddress,
        ...(e.target as any).batch,
      };
    } else {
      const { name, value } = e.target;
      updatedAddress = {
        ...formData.collectionAddress,
        [name]: value,
      };
    }
    
    setFormData((prev) => ({
      ...prev,
      collectionAddress: updatedAddress,
    }));
    validateAddresses(updatedAddress, formData.deliveryAddress);
  };

  const handleDeliveryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let updatedAddress;
    
    // Handle batch update for clearing addresses
    if (e.target.dataset?.batchUpdate && (e.target as any).batch) {
      updatedAddress = {
        ...formData.deliveryAddress,
        ...(e.target as any).batch,
      };
    } else {
      const { name, value } = e.target;
      updatedAddress = {
        ...formData.deliveryAddress,
        [name]: value,
      };
    }
    
    setFormData((prev) => ({
      ...prev,
      deliveryAddress: updatedAddress,
    }));
    validateAddresses(formData.collectionAddress, updatedAddress);
  };

  return {
    handleCollectionChange,
    handleDeliveryChange,
  };
};
